import { Modal } from '@studiometa/ui';

/**
 * Popin Comptability class.
 */
export default class PopinComptability extends Modal {
  static config = {
    name: 'PopinComptability',
    refs: ['btnClose', 'btnOpen', 'content', 'overlay'],
  };

  /**
   *
   */
  onOverlayClick() {
    this.closePopin();
  }

  /**
   *
   */
  onBtnOpenClick() {
    this.showPopin();
  }

  /**
   *
   */
  onBtnCloseClick() {
    this.closePopin();
  }

  /**
   * Close when press Escape key
   * @param  {object} options key
   * @param  {object} options.ESC key
   * @returns {void}
   */
  keyed({ ESC }) {
    if (this.opened && ESC) {
      this.closePopin();
    }
  }

  /**
   * Show Popin
   * @returns {void}
   */
  showPopin() {
    this.opened = true;
    this.$refs.content.classList.remove('opacity-0', 'pointer-events-none');
    document.documentElement.classList.add('overflow-hidden');
  }

  /**
   * Close popin
   * @returns {void}
   */
  closePopin() {
    this.$refs.content.classList.add('opacity-0', 'pointer-events-none');
    this.opened = false;
    document.documentElement.classList.remove('overflow-hidden');
  }
}
